export default __webpack_public_path__ + "static/lb-13-07fd635c83d904e48d7e6db915d9e2cf.webp";